import { render, staticRenderFns } from "./VisitorVisaView.vue?vue&type=template&id=6f28e1f2&scoped=true"
import script from "./VisitorVisaView.vue?vue&type=script&lang=js"
export * from "./VisitorVisaView.vue?vue&type=script&lang=js"
import style0 from "./VisitorVisaView.vue?vue&type=style&index=0&id=6f28e1f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28e1f2",
  null
  
)

export default component.exports